import { render, staticRenderFns } from "./AddCoaching.vue?vue&type=template&id=06360d63&scoped=true"
import script from "./AddCoaching.vue?vue&type=script&lang=js"
export * from "./AddCoaching.vue?vue&type=script&lang=js"
import style0 from "./AddCoaching.vue?vue&type=style&index=0&id=06360d63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06360d63",
  null
  
)

export default component.exports